export default {
  Title: 'Select Your Caregiving Skills and Languages',
  SkillsServicesTitle: 'Skills & Services',
  SkillsServicesSubtitle: 'Choose all conditions you\'ve worked with in the past.',
  SkillsSelectedCount: 'Skills Selected (#{count}):',
  LanguagesTitle: 'Languages',
  LanguagesSubtitle: 'Tell us about any languages you know',
  LanguagesSelect: 'Enter the name of the language *',
  LanguagesSelectPlaceholder: 'e.g., Urdu',
  AddLanguageButton: 'Add Language',
  LanguagesSelectedCount: 'Languages Selected (#{count}):',
  RemoveLanguageButton: 'Remove Language',
  AvailableSkills: {
    Dementia: 'Dementia / Alzheimer\'s',
    Parkinson: 'Parkinson\'s Disease',
    Stroke: 'Stroke Recovery',
    Diabetes: 'Diabetes',
    COPD: 'COPD / Respiratory Conditions',
    Cancer: 'Cancer / Chemotherapy Support',
    Palliative: 'Palliative Care',
  },
  AvailableLanguages: {
    English: 'English',
    French: 'French',
    Mandarin: 'Mandarin',
    Cantonese: 'Cantonese',
    Hindustani: 'Hindustani',
    Spanish: 'Spanish',
    Punjabi: 'Punjabi',
    Arabic: 'Arabic',
    Tagalog: 'Tagalog',
    Italian: 'Italian',
    German: 'German',
    Portuguese: 'Portuguese',
    Persian: 'Persian',
    Russian: 'Russian',
    Tamil: 'Tamil',
    Vietnamese: 'Vietnamese',
    Gujarati: 'Gujarati',
    Polish: 'Polish',
    Korean: 'Korean',
    SerboCroatian: 'Serbo-Croatian',
    Greek: 'Greek',
    HaitianCreole: 'Haitian Creole',
    Ukrainian: 'Ukrainian',
    Bengali: 'Bengali',
    Romanian: 'Romanian',
    Dutch: 'Dutch',
    Cree: 'Cree',
    Japanese: 'Japanese',
    Hebrew: 'Hebrew',
    Turkish: 'Turkish',
    Malayalam: 'Malayalam',
    Hungarian: 'Hungarian',
    Ilocano: 'Ilocano',
    Somali: 'Somali',
    Swahili: 'Swahili',
    Telugu: 'Telugu',
    Other: 'Other Language',
  },
  FluencyHelpText: 'Choose the option that best matches how well you can speak and understand this language, from basic to native level.',
  Fluency: {
    Basic: 'Basic',
    Conversational: 'Conversational',
    Fluent: 'Fluent',
    Native: 'Native',
  },
};
